"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identify = exports.getAllFeatureFlags = exports.FeatureFlag = exports.LaunchDarkly = undefined;

var _utils = require("./lib/utils");

Object.defineProperty(exports, "getAllFeatureFlags", {
  enumerable: true,
  get: function get() {
    return _utils.getAllFeatureFlags;
  }
});
Object.defineProperty(exports, "identify", {
  enumerable: true,
  get: function get() {
    return _utils.identify;
  }
});

var _LaunchDarkly2 = require("./components/LaunchDarkly");

var _LaunchDarkly3 = _interopRequireDefault(_LaunchDarkly2);

var _FeatureFlag2 = require("./components/FeatureFlag");

var _FeatureFlag3 = _interopRequireDefault(_FeatureFlag2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.LaunchDarkly = _LaunchDarkly3.default;
exports.FeatureFlag = _FeatureFlag3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-launch-darkly/build/index.js
// module id = 18
// module chunks = 0